import {
  ClientDetailsDto,
  ClientDto,
  CreateClientRequest,
  UpdateClientRequest,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const clientsRequests = {
  getClient: EndpointDefinition.get<ClientDto, { id: number }>({
    name: 'getClientById',
    route: '/clients/:id',
  }),
  getAllClients: EndpointDefinition.get<
    ClientDto[],
    { includeConsents?: boolean }
  >({
    name: 'getAllClients',
    route: '/clients',
  }),
  getClientDetails: EndpointDefinition.get<ClientDetailsDto, { id: number }>({
    name: 'getClientDetails',
    route: '/clients/:id/details',
  }),
  updateClient: EndpointDefinition.patch<
    ClientDto,
    UpdateClientRequest,
    { id: number }
  >({
    name: 'updateClient',
    route: '/clients/:id',
  }),
  createClient: EndpointDefinition.post<ClientDto, CreateClientRequest, null>({
    name: 'createClient',
    route: '/clients',
  }),
};
